module.exports = __webpack_public_path__ + "static/media/senseview-1.39a97cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/section-images/senseview-1.png
// module id = 91
// module chunks = 0